import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';

const SortDropdown = () => {
    const containerRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const sortDropdown = useSelector((state) => state.sortDropdown);
    const { options = [] } = sortDropdown?.payload || {};
    const label = translate('code.category.sorting');
    const selectedOption = useMemo(
        () => options.find((option) => option.selected) || options[0] || null,
        [options]
    );

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                containerRef.current &&
                !containerRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () =>
            document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown);
            return () => document.removeEventListener('keydown', handleKeyDown);
        }
    }, [isOpen]);

    const handleSelect = (value) => {
        if (!value) {
            return;
        }

        setIsOpen(false);

        const normalizedValue = value.replaceAll('&amp;', '&');
        const currentUrl = new URL(window.location.href);
        const selectedUrl = new URL(normalizedValue, currentUrl);
        const mergedSearchParams = new URLSearchParams(currentUrl.search);

        const sortParamKeys = ['sort_by', 'sort_direction'];

        sortParamKeys.forEach((key) => {
            mergedSearchParams.delete(key);
        });

        sortParamKeys.forEach((key) => {
            const paramValue = selectedUrl.searchParams.get(key);
            if (paramValue) {
                mergedSearchParams.set(key, paramValue);
            }
        });

        selectedUrl.search = mergedSearchParams.toString();
        window.location.assign(selectedUrl.toString());
    };

    if (!selectedOption) {
        return null;
    }

    return (
        <div className="sort-dropdown" ref={containerRef}>
            <div className="sort-dropdown__label">{label}</div>
            <div className={`sort-dropdown__menu${isOpen ? ' is-open' : ''}`}>
                <button
                    type="button"
                    className="sort-dropdown__trigger"
                    aria-haspopup="listbox"
                    aria-label={label}
                    aria-expanded={isOpen}
                    onClick={() => setIsOpen((prev) => !prev)}
                >
                    <span>{selectedOption.text}</span>
                </button>
                {isOpen && (
                    <div
                        className="sort-dropdown__options"
                        role="listbox"
                        aria-label={label}
                    >
                        {options.map((option, index) => (
                            <button
                                type="button"
                                key={`sort-dropdown-option-${index}`}
                                className={`sort-dropdown__option${option.selected
                                        ? ' sort-dropdown__option--selected'
                                        : ''
                                    }`}
                                role="option"
                                aria-selected={option.selected}
                                onClick={() => handleSelect(option.value)}
                            >
                                {option.text}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SortDropdown;
